/* AML apothecary scent cards - 2.17 (2026-09-13)
   Loaded (deferred) only by sections/aml-scent-cards.liquid.
   1. Family chips filter the cards and update the count line.
   2. View transition hand-off: the clicked card's photo box is named
      "aml-scent" just before navigation (never more than one element), and the
      name is cleared again whenever the page is shown or revealed. */
(() => {
  const VT_NAME = 'aml-scent';

  function clearNames() {
    document.querySelectorAll('.aml-sc__photo').forEach((el) => {
      if (el.style.viewTransitionName) el.style.viewTransitionName = '';
    });
  }

  function initSection(root) {
    if (root.dataset.amlScInit) return;
    root.dataset.amlScInit = 'true';

    const chips = root.querySelector('.aml-sc__chips');
    const count = root.querySelector('.aml-sc__count-text') || root.querySelector('.aml-sc__count');
    const allBtn = root.querySelector('.aml-sc__all');
    const items = Array.from(root.querySelectorAll('.aml-sc__item'));

    if (chips) {
      let active = 'all';
      const render = () => {
        let shown = 0;
        items.forEach((item) => {
          const on = active === 'all' || item.dataset.family === active;
          item.hidden = !on;
          if (on) shown += 1;
        });
        chips.querySelectorAll('.aml-sc__chip').forEach((chip) => {
          chip.setAttribute('aria-pressed', String(chip.dataset.family === active));
        });
        if (count) {
          const noun = shown === 1 ? 'scent' : 'scents';
          count.textContent = active === 'all' ? `${shown} ${noun}` : `${shown} ${noun} · ${active}`;
        }
        if (allBtn) allBtn.hidden = active === 'all';
      };
      // 2.43: "all" is off the chip row. A second press on the active family, or "show all", goes back to every scent.
      if (allBtn) allBtn.addEventListener('click', () => { active = 'all'; render(); });
      chips.addEventListener('click', (event) => {
        const chip = event.target.closest('.aml-sc__chip');
        if (!chip || !chips.contains(chip)) return;
        active = active === chip.dataset.family ? 'all' : chip.dataset.family;
        render();
      });
    }

    root.addEventListener('click', (event) => {
      const card = event.target.closest('.aml-sc__card');
      if (!card || !root.contains(card)) return;
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const photo = card.querySelector('.aml-sc__photo');
      if (!photo) return;
      clearNames();
      photo.style.viewTransitionName = VT_NAME;
    });
  }

  function initAll() {
    document.querySelectorAll('.aml-sc').forEach(initSection);
  }

  /* 2.35, Dan: "when you click on a scent ... the image should expand ... so that it becomes the mood background".
     Measured on live 2.34: the click handler's name never reached the snapshot (the card photo was still
     view-transition-name: none when the page was captured), so only a page-wide fade ran. The name is now set
     in pageswap, the moment the browser captures the outgoing page, on the card whose link is the destination;
     the click handler above stays as the fallback for browsers that fire click but not pageswap. */
  window.addEventListener('pageswap', (event) => {
    if (!event.viewTransition) return;
    const to = event.activation && event.activation.entry && event.activation.entry.url;
    if (!to) return;
    let card = null;
    document.querySelectorAll('.aml-sc__card').forEach((a) => { if (!card && a.href === to) card = a; });
    if (!card) {
      const v = new URL(to).searchParams.get('variant');
      if (v) document.querySelectorAll('.aml-sc__card').forEach((a) => { if (!card && new URL(a.href).searchParams.get('variant') === v) card = a; });
    }
    const photo = card && card.querySelector('.aml-sc__photo');
    if (!photo) return;
    clearNames();
    photo.style.viewTransitionName = VT_NAME;
  });

  window.addEventListener('pageshow', clearNames);
  window.addEventListener('pagereveal', clearNames);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor: re-init a section when it is re-rendered.
  document.addEventListener('shopify:section:load', initAll);
})();
